<template>
  <div>
    <RevTag
      v-if="isUploadPending"
      :label="i18n(translations.processing)"
      variant="secondary"
    />
    <RevTag
      v-if="isUploadSuccess"
      :label="i18n(translations.completed)"
      variant="success"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTag } from '@ds/components/Tag'

import translations from './UploadStatus.translations'

const i18n = useI18n()

withDefaults(
  defineProps<{
    isUploadPending: boolean
    isUploadSuccess: boolean
  }>(),
  { isUploadPending: false, isUploadSuccess: false },
)
</script>
